import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function($) {
    let totalProjects = 999,
        moreEachPage = 999,
        items = $('.project-item'),
        loading = false;

    // Function to handle displaying the currently visible projects
    function handleVisibleProjects() {
        items.each(function(i, e) {
            if (i < totalProjects) {
                $(e).removeClass('d-none').addClass('visible');

                // Create ScrollTrigger for each item
                ScrollTrigger.create({
                    trigger: e,
                    start: "top 100%",
                    // markers: true,
                    onEnter: function() {
                        gsap.to(e, {
                            duration: 0.75,
                            autoAlpha: 1,
                            y: 0,
                            ease: "power2.out"
                        });
                    }
                });
            }
        });
    }

    // Check if any .project-item elements exist before proceeding
    if (items.length > 0) {
        // Set initial state for project items (hidden with y offset)
        gsap.set(".project-item", { y: 100, autoAlpha: 0 });
        handleVisibleProjects();

        $(window).on('scroll', function() {
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500 && !loading) {
                loading = true;
                totalProjects += moreEachPage;
                handleVisibleProjects();
                setTimeout(function() {
                    loading = false;
                }, 500);
            }
        });
    } else {
        // console.log('No project items found on the page.');
    }


    $(window).on('scroll', function() {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500 && !loading) {
            loading = true;
            totalProjects += moreEachPage;
            handleVisibleProjects();
            setTimeout(function() {
                loading = false;
            }, 500);
        }
    });
});
